import { render, staticRenderFns } from "./ModifyMemberTalkDetail.vue?vue&type=template&id=904644f4&scoped=true&"
import script from "./ModifyMemberTalkDetail.vue?vue&type=script&lang=js&"
export * from "./ModifyMemberTalkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904644f4",
  null
  
)

export default component.exports